<template>
  <div>
    <PageAllow controller="Quotations" :action="isView ? 'view' : mode" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color py-4 mx-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{
                mode == "fromProducts"
                  ? $t("PurchasesList.add.product")
                  : mode == "fromSupplier"
                  ? $t("PurchasesList.add.supplier")
                  : $t("CRUD.info", [$t("PurchasesDetail.ObjectName")])
              }}
              <v-chip
                v-if="quotation.cancel_flg"
                small
                label
                outlined
                class="ms-4 mt-1"
                color="danger"
              >
                {{ $t("CRUD.cancelled") }}
              </v-chip>
              <v-chip
                small
                label
                class="ms-4 mt-1"
                :color="quotation.status | quotationStatusColor"
                :text-color="quotation.status | quotationStatusTextColor"
              >
                {{ quotation.status | quotationStatusText }}
              </v-chip>
              <v-chip
                v-if="quotation.status == 1"
                small
                label
                class="ms-4 mt-1"
                :color="quotation.question_flg | quotationQuestionFlgsColor"
                :text-color="
                  quotation.question_flg | quotationQuestionFlgsTextColor
                "
              >
                {{ quotation.question_flg | quotationQuestionFlgsText }}
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <!-- 保存编辑 -->
                <v-btn
                  v-if="
                    isConfirm &&
                    $permission.permissionAllow('Quotations', 'confirm')
                  "
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="doSubmit('confirm')"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("Quotations.actions.confirm") }}
                </v-btn>
                <v-btn
                  v-if="
                    isConfirm &&
                    $permission.permissionAllow('Quotations', 'question')
                  "
                  small
                  dark
                  color="danger"
                  class="px-2 me-2 mb-1"
                  @click.stop="doSubmit('question')"
                >
                  <v-icon x-small class="pe-1">fa-question-circle</v-icon>
                  {{ $t("Quotations.actions.question") }}
                </v-btn>
                <v-btn
                  v-if="
                    isApprove &&
                    $permission.permissionAllow('Quotations', 'approve')
                  "
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="doSubmit()"
                >
                  <v-icon x-small class="pe-1">fa-stamp</v-icon>
                  {{ $t("Quotations.actions.approve") }}
                </v-btn>
              </v-sheet>
              <QuotationsActions
                v-if="isView"
                :quotation="quotation"
                :showConfirm="quotation.actions && quotation.actions.confirm"
                :showApprove="quotation.actions && quotation.actions.approve"
                :showCancel="quotation.actions && quotation.actions.cancel"
                class="ml-3"
              />
            </v-card-title>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Quotations.Fields.quotation_code") }}
                    {{ $t("Global.colon") }}
                  </span>
                  {{ quotation.quotation_code }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Quotations.Fields.supplier_name") }}
                    {{ $t("Global.colon") }}
                  </span>
                  {{
                    quotation && quotation.supplier
                      ? quotation.supplier.supplier_name
                      : ""
                  }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Quotations.Fields.last_modified_user") }}
                    {{ $t("Global.colon") }}
                  </span>
                  {{
                    quotation && quotation.modifier
                      ? quotation.modifier.name
                      : ""
                  }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="!isConfirm">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Quotations.Fields.confirm_user") }}
                    {{ $t("Global.colon") }}
                  </span>
                  {{
                    quotation && quotation.confirmer
                      ? quotation.confirmer.name
                      : ""
                  }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Quotations.Fields.created_time") }}
                    {{ $t("Global.colon") }}
                  </span>
                  {{ quotation.created | formatTime }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Quotations.Fields.finished_time") }}
                    {{ $t("Global.colon") }}
                  </span>
                  {{ quotation.complete_date | formatTime }}
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
          <v-expansion-panel v-if="isView">
            <v-expansion-panel-header class="py-0">
              <v-tabs v-model="tab" background-color="transparent">
                <v-tab
                  @click.stop="
                    tab = 0;
                    panels.find((p) => p == 1) ? null : panels.push(1);
                  "
                >
                  {{ $t("StockOrderIN.actions.activities") }}
                </v-tab>
              </v-tabs>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-data-table
                      :headers="activitiesHeaders"
                      :items="activities_details"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-data-table
        id="quotation_details_table"
        :headers="detailsHeaders"
        :items="quotationDetailItems"
        :search="filter"
        disable-sort
        class="elevation-2 px-4 mt-4"
        disable-pagination
        hide-default-footer
        :no-data-text="$t('Order.DetailNoData')"
      >
        <template v-slot:top>
          <v-toolbar flat class="transparent-background-color">
            <v-toolbar-title class="ms-n2">
              {{ $t("CRUD.details", [$t("Quotations.ObjectName")]) }}
            </v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-toolbar
            flat
            class="transparent-background-color"
            align-self="center"
          >
            <v-row no-gutters class="me-n3">
              <span class="caption secondary--text pt-2">
                {{
                  $t(
                    "$vuetify.dataFooter.pageText",
                    quotation_details
                      ? [
                          quotation_details.length > 0 ? 1 : 0,
                          quotation_details.length,
                          quotation_details.length,
                        ]
                      : [0, 0, 0]
                  )
                }}
              </span>
              <v-row no-gutters>
                <v-spacer />
                <v-col cols="12" sm="9" md="8">
                  <v-text-field
                    v-model="filter"
                    clearable
                    hide-details
                    :label="$t('Search.filter')"
                  />
                </v-col>
              </v-row>
            </v-row>
          </v-toolbar>
        </template>

        <template v-slot:item.old_supply_price="{ item }">
          {{ $t("Global.money") }}{{ item.old_supply_price | formatMoney }}
        </template>
        <template v-slot:item.current_supply_price="{ item }">
          <a
            @click.stop="
              currentDetail = item;
              lineChartMaterialName = item.Description;
              echartsDialog = true;
            "
          >
            {{ $t("Global.money") }}
            {{ item.current_supply_price | formatMoney }}
          </a>
        </template>
        <template v-slot:item.new_supply_price="{ item }">
          <span v-if="isView">
            {{ $t("Global.money") }}{{ item.new_supply_price | formatMoney }}
          </span>
          <v-text-field
            v-else
            v-model="item.new_supply_price"
            single-line
            dense
            hide-details
            type="number"
            min="0"
            :prefix="$t('Global.money')"
            disabled
            style="max-width: 80px; margin-left: auto"
          />
        </template>
        <template v-slot:header.use_flg="{ header }">
          <v-checkbox
            v-if="isConfirm"
            v-model="useAll"
            :true-value="1"
            :false-value="0"
            class="mr-0"
            style="display: inline-block"
            @change="checkAll()"
          >
            <template v-slot:label>
              <span class="caption font-weight-bold ms-n2">
                {{ header.text }}
              </span>
            </template>
          </v-checkbox>
          <span v-else>{{ header.text }}</span>
        </template>
        <template v-slot:item.use_flg="{ item }">
          <div v-if="isConfirm" class="d-flex mt-n2 mb-n3 ml-12">
            <v-checkbox
              align="center"
              color="primary"
              v-model="item.use_flg"
              :true-value="1"
              :false-value="0"
            >
              <template v-slot:label>
                <span class="caption ms-n2">
                  {{
                    $t(
                      item.use_flg
                        ? "Quotations.useFlgs.yes"
                        : "Quotations.useFlgs.no"
                    )
                  }}
                </span>
              </template>
            </v-checkbox>
          </div>
          <span v-else>
            {{ item.use_flg | quotationUseFlgsText }}
          </span>
        </template>
        <template v-slot:item.memo="{ item }">
          <v-text-field
            v-if="isConfirm"
            v-model="item.memo"
            single-line
            dense
            hide-details
            style="max-width: 120px"
          >
            <template v-slot:append>
              <v-icon
                x-small
                @click.stop="
                  detail_memo_item = item;
                  memoDialog = true;
                "
                class="pt-2 pb-1 primary--text"
              >
                fa-edit
              </v-icon>
            </template>
          </v-text-field>
          <span v-else>
            {{ item.memo }}
          </span>
        </template>
      </v-data-table>
    </v-sheet>

    <v-dialog v-model="memoDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span
            class="red--text d-inline-block text-truncate"
            style="max-width: 360px"
          >
            {{
              $t("Material.materialNameWithCode", [
                detail_memo_item.material_code,
                detail_memo_item.material_name,
              ])
            }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="memoDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea
            v-model="detail_memo_item.memo"
            outlined
            :label="$t('Order.DetailFields.memo')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="memoDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogEconomyHistoryEcharts
      v-model="echartsDialog"
      :supplierId="quotation.supplier_id"
      :currentDetail="currentDetail"
      :lineChartMaterialName="lineChartMaterialName"
      @close="echartsDialog = false"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import QuotationsActions from "./plugins/Actions";
import Quotations from "@/api/quotations";
import DialogEconomyHistoryEcharts from "@/components/plugins/DialogEconomyHistoryEcharts"

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    DialogEconomyHistoryEcharts,
    QuotationsActions,
  },
  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.purchases"),
          disabled: false,
          href: "/purchases",
        },
        {
          text: i18n.t("Nav.quotation"),
          href: "/quotations",
          disabled: false,
        },
        {
          text: this.isConfirm
            ? i18n.t("Nav.quotationsConfirm")
            : this.isApprove
            ? i18n.t("Nav.quotationsApprove")
            : i18n.t("Nav.quotationsDetail"),
          disabled: true,
        },
      ];
      if (this.quotation && this.quotation.quotation_code) {
        items.push({
          text: this.quotation.quotation_code,
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    isView() {
      return !this.mode;
    },
    isConfirm() {
      return this.mode == "confirm";
    },
    isApprove() {
      return this.mode == "approve";
    },

    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("Quotations.DetailFields.material_category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("Quotations.DetailFields.material_name"),
          align: "start",
          value: "Description",
        },
        {
          text: i18n.t("Quotations.DetailFields.unit"),
          align: "center",
          value: "unit",
        },
        {
          text: i18n.t("Quotations.DetailFields.last_supply_price"),
          align: "end",
          value: "old_supply_price",
        },
        {
          text: i18n.t("Quotations.DetailFields.current_supply_price"),
          align: "end",
          value: "current_supply_price",
        },
        {
          text: i18n.t("Quotations.DetailFields.supplier_quote_price"),
          align: "end",
          value: "new_supply_price",
        },
        {
          text: i18n.t("Quotations.DetailFields.use_flg"),
          align: "center",
          value: "use_flg",
        },
        {
          text: i18n.t("Quotations.DetailFields.memo"),
          align: "center",
          value: "memo",
        },
      ];

      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }

      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("Quotations.ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("Quotations.ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("Quotations.ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],

    quotationDetailItems() {
      return this.quotation_details.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [detail.material_code, detail.material_name, detail.standard_name]
        );
        return detail;
      });
    },

    ...mapState(["settings", "accountUser", "accountInfo"]),
  },

  data: () => ({
    tab: null,
    panels: [0],
    mode: "",
    quotation: {},
    activities_details: [],
    quotation_details: [],
    filter: "",
    useAll: 0,
    memoDialog: false,
    detail_memo_item: { memo: "" },
    echartsDialog: false,
    currentDetail: null,
    lineChartMaterialName: "",
  }),

  mounted() {
    this.mode = this.$route.params.mode;
    if (this.mode) this.$router.replace("/quotations/" + this.$route.params.id);
  },

  methods: {
    getQuotationFromAPI() {
      Quotations.fetchOne(this.$route.params.id, { order_activity: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.quotation = response.data.quotation;
            this.quotation_details = response.data.quotation.quotation_details;
            //设置默认采用各商品
            if (this.quotation.status == 1 && this.quotation.question_flg == 0) {
              this.quotation_details.forEach((detail) => {
                if (!detail.use_flg) {
                  detail.use_flg = 1;
                }
              });
            }
            this.activities_details = response.data.order_activities;
          }
        }.bind(this)
      );
    },
    checkAll() {
      if (
        this.useAll &&
        this.quotation_details.filter((detail) => detail.use_flg).length <
          this.quotation_details.length
      ) {
        this.quotation_details.map((detail) => {
          if (!detail.use_flg) {
            detail.use_flg = 1;
          }
        });
      } else if (
        !this.useAll &&
        this.quotation_details.filter((detail) => detail.use_flg).length ==
          this.quotation_details.length
      ) {
        this.quotation_details.map((detail) => {
          if (detail.use_flg) {
            detail.use_flg = 0;
          }
        });
      }
    },
    submitMethod(action) {
      if (action == "confirm")
        return Quotations.confirm(this.quotation.id, this.quotation);
      else if (action == "question")
        return Quotations.question(this.quotation.id, this.quotation);
      else if (this.isApprove) return Quotations.approve(this.quotation.id);
    },
    doSubmit(action) {
      this.submitMethod(action).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.push("/quotations");
          }
        }.bind(this)
      );
    },
  },

  watch: {
    $route(to) {
      if (to.params.mode) {
        this.mode = to.params.mode;
        this.$router.replace("/quotations/" + this.$route.params.id);
      }
    },
    mode: {
      handler() {
        if (this.$route.params.id) {
          this.getQuotationFromAPI();
        }
      },
    },
    quotation_details: {
      deep: true,
      handler() {
        //全选CheckBox的联动
        if (
          this.quotation_details.filter((detail) => detail.use_flg).length ==
            this.quotation_details.length &&
          !this.useAll
        ) {
          this.useAll = 1;
        } else if (
          this.quotation_details.filter((detail) => detail.use_flg).length <
            this.quotation_details.length &&
          this.useAll
        ) {
          this.useAll = 0;
        }
      },
    },
  },
};
</script>